import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { EquipmentIdentifier, EquipmentLog } from '../equipment-log.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-equipment-log',
  templateUrl: './equipment-log.component.html',
  styleUrls: ['./equipment-log.component.scss']
})
export class EquipmentLogComponent implements OnInit {

  @Input() equipmentIdentifier: EquipmentIdentifier;

  ngOnChanges() {
    this.load();
  }


  equipmentLogs = new Array<EquipmentLog>();

  constructor(private httpService: HttpService, public translationService: TranslationService) { }

  ngOnInit() {
    this.load();
  }

  load() {
    if (this.equipmentIdentifier == null) {
      return;
    }
    this.httpService.postWithContext<EquipmentLog[]>(environment.equipment + '/get-log', this.equipmentIdentifier).subscribe(response => {
      const tempEquipmentLogs = new Array<EquipmentLog>();
      response.forEach(equipmentLog =>
        tempEquipmentLogs.push(new EquipmentLog(equipmentLog))
      );
      this.equipmentLogs = tempEquipmentLogs;
    })
  }

}
